import Config from "../source/Config";

export type ILang = 'hu' | 'en';
export class Lng {
    private static content = {
        'en': {
            'empty': '',

            'registration': 'Registration',
            'login': 'Login',
            'forgot_password?': 'Forgot password?',
            'username': 'Name',
            'password': 'Password',
            'user_reg': 'User registration',
            'restaurant_reg': 'Professional registration',
            'back_to_login': 'Back to login',

            'userreg_title': 'User registration',
            'userreg_rest_title': 'Restaurant registration',
            'userreg_firstname': 'First name',
            'userreg_lastname': 'Last name',
            'userreg_phone': 'Phone',
            'userreg_position': 'Position',
            'userreg_username': 'Username',
            'userreg_password': 'Password',
            'userreg_rest_name': 'Restaurant name',
            'userreg_rest_type': 'Restaurant type',
            'userreg_regbtn': 'Registration',

            'resetpw_titel': 'Reset your password',
            'resetpw_enteremail': 'Enter your user account\'s verified email address and we will send you a password reset link.',
            'resetpw_enteremailinput': 'Enter your email address',
            'resetpw_sendbtn': 'Send password reset email',
            'resetpw_sending': 'Sending...',

            'user_handover_loading': 'Loading...',
            'user_handover_ordered': 'Ordered:',
            'user_handover_payed': 'Payed:',
            'user_handover_thankyou': 'thank you!',
            'user_handover_starbuckscardno': 'Starbucks card number',
            'user_handover_comporder': 'Completing order',
            'user_handover_orderisempty': 'Orders is empty!',

            'user_offeritem_pickuptime': 'Pick up time:',
            'user_offeritem_today': 'today',

            'countdown_timeout': 'Timeout!',
            'countdown_receivable': 'Your order will be receivable:',
            'countdown_willready': 'Your order will be ready in:',
            'countdown_h': 'h',
            'countdown_min': 'min',
            'countdown_sec': 'sec',

            'user_payment_pmnotaccepted': 'This payment method not accepted in web application.',
            'user_payment_loading': 'Loading...',
            'user_payment_read': 'Read',
            'user_payment_pickup': 'Pick up time:',
            'user_payment_today': 'today',
            'user_payment_yourorder': 'Your order:',
            'user_payment_sobrascredit': 'Sobras! Credit',
            'user_payment_thankyou': 'thank you!',
            'user_payment_perspickup': 'personal pick up',
            'user_payment_delivery': 'delivery',
            'user_payment_billingaddress': 'Billing address:',
            'user_payment_placingorder': 'By placing an order you agree to our',
            'user_payment_tandc': 'Terms & Conditions',
            'user_payment_empty': 'Orders is empty!',
            'user_payment_order': 'Order',
            'user_payment_success': 'Successfully payment',
            'user_payment_next': 'Next',
            'user_payment_back': 'back to orders',

            'user_profile_loading': 'Loading...',
            'user_profile_plsfill': 'Please fill all fields.',
            'user_profile_logout': 'Logout',
            'user_profile_changepw': 'Change password',
            'user_profile_yourhome': 'Where is your home?',
            'user_profile_yourwork': 'Where do you work?',
            'user_profile_agegroup': 'Age group',
            'user_profile_chooseone': 'Please choose one.',
            'user_profile_whatdoulike': 'What do you like?',
            'user_profile_agreetoour': 'Agree to our',
            'user_profile_tandc': 'Terms & Conditions',
            'user_profile_privacypol': 'Data Protection Notice',
            'user_profile_privacypol2': 'Data Protection Notice',
            'user_profile_aszf': 'General Terms and Conditions',
            'user_profile_aszf2': 'General Terms and Conditions',
            'user_profile_adattovabbitasi_nyilatkozat': 'Adattovábbítási nyilatkozat',
            'user_profile_adattovabbitasi_nyilatkozat2': 'Adattovábbítási nyilatkozatot',
            'user_profile_saving': 'Saving...',
            'user_profile_done': 'Save',

            'user_rating_success': 'Successfull save',
            'user_rating_raterest': 'Rate the restaurant!',
            'user_rating_loading': 'Loading...',
            'user_rating_restnotfound': 'Restaurant not found!',
            'user_rating_thx': 'thank you!',
            'user_rating_send': 'SEND',
            'user_rating_comment': 'Comment',

            'user_restmap_today': 'today',
            'user_restmap_startnav': 'start navigation',

            'user_userindex_offers': '<b>Offers</b><br />near you',
            'user_userindex_fav': '<b>Favourite</b><br />restaurants',
            'user_userindex_rests': '<b>Restaurants</b><br />you ordered from',
            'user_userindex_mapsearch': '<b>MAP</b><br />search',

            'user_restlist_enalbegeo': 'Please enable the geolocation!',
            'user_restlist_loading': 'Loading...',
            'user_restlist_noaoffernearby': 'There is no active offer nearby',
            'user_restlist_extradeal': 'extra deal!',
            'user_restlist_sponsor': 'Sponsor',
            'user_restlist_left': 'left', // mint h ennyi maradt
            'user_restlist_today': 'today:',
            'user_restlist_emptyresult': 'Empty result!',
            'user_viewrest_goodchoice': 'good choice!',
            'user_viewrest_pickuptime': 'Pick up time:',
            'user_viewrest_today': 'today',
            'user_viewrest_sc': 'Sobras! Credit',
            'user_viewrest_submit': 'SUBMIT ORDER',
            'user_viewrest_ings': 'Ingredients and allergens',
            'user_viewrest_whatisa': 'what is a',
            'user_viewrest_plsnote': ' Please note that this box may contain products that you may be allergic to. We can\'t predict the contents of the box in advance, so ask the store when pick up.',
            'user_viewrest_enjoy': 'Enjoy your meal!',
            'user_viewrest_accept': 'accept',
            'user_viewrest_read': 'Read',
            'more': 'more',
            'less': 'less',
            'details': 'details',


            'user_viewrest_': '',

            'please_enable_the_geolocation': 'Please enable the geolocation!',
            'address' : 'Address',
            'use_my_location' : 'Use my location',
            'city' : 'city',
            'country' : 'country',
            'state' : 'state',
            'street_house_number' : 'street, house number',
            'zip' : 'zip',
            'Bank transfer' : 'Bank transfer',
            'map_search' : 'Map search',
            'restaurants_you_ordered_from' : 'Restaurants you ordered from',
            'sort_by' : 'Sort by',
            'favourite_restaurants' : 'Favourite restaurants',
            'back_to_all_offers' : 'back to all offers',
            'offers_near_you' : 'Offers near you',
            'route'      : 'route',
            'search'     : 'Search',
            'you_have'     : 'You have',
            'meals'     : 'meals',
            'profile'     : 'Profile',


            'Vegan'      : 'Vegan',
            'Meatlover'  : 'Meatlover',
            'Fast Food'  : 'Fast Food',
            'Fishes'     : 'Fishes',
            'Gluten Free': 'Gluten Free',
            'Sugarfree'  : 'Sugarfree',
            'Pasta'      : 'Pasta',
            'Salad'      : 'Salad',
            'Burgers'    : 'Burgers',
            'Sandwich'   : 'Sandwich',
            'Dessert'    : 'Dessert',
            'payment'    : 'payment',
            'order_pick_up_details'    : 'Order pick up details',
            'Sign in with Apple'    : 'Sign in with Apple',
            'Saved successfully!'    : 'Saved successfully!',
            'Ingredients and allergens'    : 'Ingredients and allergens',
            'Close'    : 'Close',
            'Starbucks card'    : 'Starbucks card',
            'starbucks'         : 'starbucks',
            'The password can be up to 8 characters long!'    : 'The password can be up to 8 characters long!',
            'Please log in first!': 'Please log in first!',
            "Back to the restaurant's offers!": "Back to the restaurant's offers!",
            "Click on the cart for details!": 'Részletekért kattints a kosárra!'
        },
        'hu': {
            'empty': '',

            'registration': 'Regisztráció',
            'login': 'Belépés',
            'forgot_password?': 'Elfelejtetted a jelszavad?',
            'username': 'felhasználónév',
            'password': 'jelszó',
            'user_reg': 'Felhasználó regisztráció',
            'restaurant_reg': 'Étterem regisztráció',
            'back_to_login': 'Vissza a belépéshez',

            'userreg_title': 'Felhasználó regisztráció',
            'userreg_rest_title': 'Étterem regisztráció',
            'userreg_firstname': 'Keresztnév',
            'userreg_lastname': 'Vezetéknév',
            'userreg_phone': 'Telefonszám',
            'userreg_position': 'Pozíció',
            'userreg_username': 'Felhasználónév',
            'userreg_password': 'Jelszó',
            'userreg_rest_name': 'Étterem neve',
            'userreg_rest_type': 'Étterem típusa',
            'userreg_regbtn': 'Regisztráció',

            'resetpw_titel': 'Állítsd vissza a jelszavad',
            'resetpw_enteremail': 'Add meg a fiókod hitelesített e-mail címét, és küldünk egy jelszó módosító linket.',
            'resetpw_enteremailinput': 'Add meg az e-mail címed',
            'resetpw_sendbtn': 'E-mail küldése',
            'resetpw_sending': 'Küldés...',

            'user_handover_loading': 'Betöltés...',
            'user_handover_ordered': 'Rendelések:',
            'user_handover_payed': 'Fizetett:',
            'user_handover_thankyou': 'köszönjük!',
            'user_handover_starbuckscardno': 'Starbucks kártyaszám',
            'user_handover_comporder': 'Rendelés teljesítése',
            'user_handover_orderisempty': 'Nincsenek rendelések!',

            'user_offeritem_pickuptime': 'Átvétel ideje:',
            'user_offeritem_today': 'ma',

            'countdown_timeout': 'Időtúllépés!',
            'countdown_receivable': 'Rendelésed átvehető:',
            // 'countdown_willready': 'Rendelésed elerhető lesz:',
            'countdown_willready': 'Rendelésed átvehető lesz:',
            'countdown_h': 'ó',
            'countdown_min': 'perc',
            'countdown_sec': 'mp',

            'user_payment_pmnotaccepted': 'Ez a fizetési mód nem elfogadható a webes alkalmazásban.',
            'user_payment_loading': 'Betöltés...',
            'user_payment_read': 'Elolvasom',
            'user_payment_pickup': 'Átvétel ideje:',
            'user_payment_today': 'ma',
            'user_payment_yourorder': 'Rendelésed:',
            'user_payment_sobrascredit': 'Sobras! Credit',
            'user_payment_thankyou': 'köszönjük!',
            'user_payment_perspickup': 'személyes átvétel',
            'user_payment_delivery': 'kiszállítás',
            'user_payment_billingaddress': 'Számlázási cím:',
            'user_payment_placingorder': 'Rendelésed leadásával hozzájárulsz a ',
            'user_payment_accept': 'elfogadásához',
            'user_payment_tandc': 'Felhasználási feltételek',
            'user_payment_empty': 'Nem található rendelés!',
            'user_payment_order': 'Rendelés',
            'user_payment_success': 'Sikeres fizetés',
            'user_payment_next': 'Következő',
            'user_payment_back': 'vissza a rendeléseimhez',

            'user_profile_loading': 'Betöltés...',
            'user_profile_plsfill': 'Töltsd ki az összes mezőt.',
            'user_profile_logout': 'Kijelentkezés',
            'user_profile_changepw': 'Jelszó módosítása',
            'user_profile_yourhome': 'Hol laksz?',
            'user_profile_yourwork': 'Hol van a munkahelyed?',
            'user_profile_agegroup': 'korcsoport',
            'user_profile_chooseone': 'Válassz',
            'user_profile_whatdoulike': 'Mit szeretsz?',
            'user_profile_agreetoour': 'Elfogadod az ',
            'user_profile_tandc': 'Felhasználási feltételeket',
            'user_profile_privacypol': 'Adatvédelmi Tájékoztató',
            'user_profile_privacypol2': 'Adatvédelmi Tájékoztatót',
            'user_profile_aszf': 'Általános Szerződési Feltételek',
            'user_profile_aszf2': 'Általános Szerződési Feltételeket',
            'user_profile_adattovabbitasi_nyilatkozat': 'Adattovábbítási nyilatkozat',
            'user_profile_adattovabbitasi_nyilatkozat2': 'Adattovábbítási nyilatkozatot',
            'user_profile_saving': 'Mentés...',
            'user_profile_done': 'Kész',

            'user_rating_success': 'Sikeres mentés',
            'user_rating_raterest': 'Értékeld az éttermet!',
            'user_rating_loading': 'Betöltés...',
            'user_rating_restnotfound': 'Étterem nem található!',
            'user_rating_thx': 'köszönjük!',
            'user_rating_send': 'KÜLDÉS',
            'user_rating_comment': 'Megjegyzés',

            'user_restmap_today': 'ma',
            'user_restmap_startnav': 'navigálás megkezdése',

            'user_userindex_offers': '<b>Ajánlatok</b><br />a közeledben',
            'user_userindex_fav': '<b>Kedvenc</b><br />éttermeid',
            'user_userindex_rests': '<b>Éttermek</b><br />ahonnan rendeltél',
            // 'user_userindex_rests': '<b>Éttermek</b><br />amelyekből rendelt',
            'user_userindex_mapsearch': '<b>Térképes</b><br />keresés',

            'user_restlist_enalbegeo': 'Kérjük, engedélyezd a geolokációt!',
            'user_restlist_loading': 'Betöltés...',
            'user_restlist_noaoffernearby': 'Nem találtunk a közeledben ajánlatokat',
            'user_restlist_extradeal': 'extra ajánlat!',
            'user_restlist_sponsor': 'Szponzor',
            'user_restlist_left': 'maradt', // mint h ennyi maradt
            'user_restlist_today': 'ma:',
            'user_restlist_emptyresult': 'nincs találat!',
            'user_viewrest_goodchoice': 'jó választás!',
            'user_viewrest_pickuptime': 'Átvétel ideje:',
            'user_viewrest_today': 'ma',
            'user_viewrest_sc': 'Sobras! Credit',
            'user_viewrest_submit': 'RENDELÉS ELKÜLDÉSE',
            'user_viewrest_ings': 'Összetevők és allergének',
            'user_viewrest_whatisa': 'Mi az a ',
            'user_viewrest_plsnote': 'Kérjük vedd figyelembe, hogy ez a termék tartalmazhat olyan összetevőt amire allergiás lehetsz. Nem tudjuk előre meghatározni a doboz tartalmát, ezért érdeklődj a felvételi ponton!',
            'user_viewrest_enjoy': 'Egészségedre!',
            'user_viewrest_accept': 'elfogadom',
            'user_viewrest_read': 'elolvasom',
            'more': 'több',
            'less': 'kevesebb',
            'details': 'részletek',

            'user_viewrest_': '',

            'please_enable_the_geolocation': 'Kérjük engedélyezze a helyzetmeghatározást!',
            'address' : 'Cím',
            'use_my_location' : 'Használja a helyzetemet',
            'city' : 'Város',
            'country' : 'Ország',
            'state' : 'állam',
            'street_house_number' : 'utca, házszám',
            'zip' : 'irányítószám',
            'Bank transfer' : 'Bankkártyás fizetés',
            'map_search' : 'Térképes keresés',
            /* 'restaurants_you_ordered_from' : 'Éttermek amelyekből rendelt', */
            'restaurants_you_ordered_from': 'Éttermek ahonnan rendeltél',
            'sort_by' : 'sorrend',
            // 'favourite_restaurants' : 'Kedvenc éttermek',
            'favourite_restaurants' : 'Kedvenc éttermeid',
            'back_to_all_offers' : 'vissza az összes ajánlathoz',
            'offers_near_you' : 'Közeli ajánlatok',
            'route'      : 'útvonal',
            'search'     : 'keresés',
            'you_have'   : 'Neked van',
            'meals'      : 'étkezés',
            'profile'    : 'Profil',

            'Vegan'      : 'Vegán',
            'Meatlover'  : 'Húsimádó',
            'Fast Food'  : 'Fast Food',
            'Fishes'     : 'Halak',
            'Gluten Free': 'Gluténmentes',
            'Sugarfree'  : 'Cukormentes',
            'Pasta'      : 'Tészta',
            'Salad'      : 'Saláta',
            'Burgers'    : 'Hamburgerek',
            'Sandwich'   : 'Szendvics',
            'Dessert'    : 'Desszert',
            'payment'    : 'fizetés',
            'order_pick_up_details'    : 'A megrendelés átvételének részletei',
            'Sign in with Apple'    : 'Bejelentkezés az Apple-lel',
            'Saved successfully!'    : 'Sikeres mentés!',
            'Ingredients and allergens'    : 'Összetevők és allergének',
            'Close'    : 'Bezárás',
            'Starbucks card'    : 'Starbucks kártya',
            'starbucks'    : 'starbucks',
            'The password can be up to 8 characters long!'    : 'A jelszó legfeljebb 8 karakter hosszú lehet!',
            'Please log in first!': 'Kérem, előbb jelentkezzen be!',
            "Back to the restaurant's offers!": 'Vissza az étterem ajánlataihoz!',
            "Click on the cart for details!": 'Részletekért kattints a kosárra!'
        },
    };
    public static get(switcher='empty', lng:ILang=null){
        if ( lng === null ) {
            lng = Config.getLang();
        }
        if (typeof this.content[lng][switcher] != "undefined") {
            return this.content[lng][switcher]
        }
        return ''
    }
}
